<template>
  <UiModal
    title="Welcome to Travel Analytics"
    size="lg"
    no-close-on-backdrop
    ok-only
    v-bind="$attrs"
  >
    <p>
      To familiarise yourself with Travel Analytics, please watch this short introduction video:
    </p>
    <div class="video">
      <video controls>
        <source :src="introVideoURL">
      </video>
    </div>
  </UiModal>
</template>

<script setup lang="ts">
import { introVideoURL } from '@/defs'

defineOptions({ name: 'IntroVideo' })
</script>

<style lang="scss" scoped>
  .video {
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: center;

    &> video {
      width: 100%;
      height: auto;
    }
  }
</style>
